import _get from 'lodash/get';

import { DEFAULT_FORM_DATA, LABEL_TYPES } from './stubs';

export function isLabelTypeConfigurable(labelType) {
  return LABEL_TYPES.includes(labelType);
}

/**
 * @returns {import("zod").z.infer<typeof import("./stubs").FORM_SCHEMA>}
 */
export function createInitialData(carrier = null) {
  if (!carrier) return DEFAULT_FORM_DATA;

  const slas = _get(carrier, 'slas', []);
  const supportedLabelTypes = _get(carrier, 'supported_label_types', []);

  const slasMap = slas.reduce((acc, sla) => {
    const id = _get(sla, 'id', '');
    acc[id] = _get(sla, 'is_active', false);
    return acc;
  }, {});

  const labelTypes = supportedLabelTypes.reduce((acc, labelTypeData) => {
    const type = _get(labelTypeData, 'type', '');
    const isEnabled = _get(labelTypeData, 'is_enabled', false);

    if (isLabelTypeConfigurable(type)) {
      acc[type] = { isEnabled };
    }
    return acc;
  }, {});

  return {
    slas: slasMap,
    labelTypes
  };
}

export function createPayload(data = {}, carrier = {}) {
  const slas = _get(data, 'slas', {});
  const labelTypes = _get(data, 'labelTypes', {});
  const supportedLabelTypes = _get(carrier, 'supported_label_types', []);

  return {
    slas_ids: Object.keys(slas),
    supported_label_types: supportedLabelTypes.reduce((acc, info) => {
      const type = _get(info, 'type', '');
      const dataset = _get(labelTypes, type, {});
      if (dataset) {
        acc.push({
          ...info,
          is_enabled: _get(dataset, 'isEnabled', false)
        });
      }
      return acc;
    }, [])
  };
}
